import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Table } from 'react-bootstrap';

import { Web3StatusContext } from "../../../contexts/Web3StatusContext";
import TransactionStatus from '../../TransactionStatus'

const { AccountData, ContractData, ContractForm } = newContextComponents;

class ChangeTaxRatio extends React.Component {
  static contextType = Web3StatusContext;

  state = {
    address: '',
    stackId: -1,
    taxRatioDataKey: null,
  };

  componentDidMount() {
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFOREST;

    const taxRatioDataKey = contract.methods["TAX"].cacheCall();
    
    this.setState({ taxRatioDataKey: taxRatioDataKey });
  }

  mySubmitHandler = (event) => {
    event.preventDefault();
    if(this.context.activeAccount == null) {
      console.log('no active account to approve');
      return;
    }
    const { drizzle } = this.props;
    const { GAMEFOREST, GAMEFORESTSale } = drizzle.contracts;

    const stackId = GAMEFOREST.methods.updateTax.cacheSend
        (this.state.address);
    this.setState({ stackId: stackId });
  }

  myAddressChangeHandler = (event) => {
    let { value } = event.target;
    const address = value;
    this.setState({address: address});
  }

  // destructure drizzle and drizzleState from props
  render() {
    var statusMsg = '';
    if (this.state.stackId >= 0) {
      statusMsg = (
        <TransactionStatus
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}
          stackId={this.state.stackId}
        >

        </TransactionStatus>
      );
    }

    var disabled = this.context.activeAccount == null;

    var taxRatio = "";
    if(!disabled) {
      const { GAMEFOREST } = this.props.drizzleState.contracts;

      var taxRatioContract = GAMEFOREST["TAX"][this.state.taxRatioDataKey];
      if(taxRatioContract != undefined) {
        if(taxRatioContract.value) {
          taxRatio = taxRatioContract.value;
        }
      }
    }

    var form = (
    <form onSubmit={this.mySubmitHandler}>
        {statusMsg}<br/>
        {taxRatio}%<br/>
        Ratio:{" "}
        <input
          value={this.state.address}
          onChange={this.myAddressChangeHandler}
        />{"%"}
        <br/>
        <input
        type='submit'
        value="Submit"
        disabled={disabled}
        />
        <br/>
    </form>
    );

    return (
      <div>
        {form}
      </div>
    );
  }
};

export default ChangeTaxRatio;
